import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';

// Nota: standard `size=` no aplica: convierte el <select> en listbox inline (siempre visible), no en un desplegable táctil.

@Component({
    selector: 'app-custom-select',
    templateUrl: './custom-select.component.html',
    styleUrls: ['./custom-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomSelectComponent implements OnInit {

  @ViewChild('suggestions') miElementoRef!: ElementRef;
  @Output() selectItemEvent = new EventEmitter<any>();
  @Input() listItems: { label: string; value: any }[] = [];
  @Input() placeholder: string = '';
  @Input() selectItem: any = {};
  @Input() preventDeleteKeys: boolean = false;
  @Input() preventNumberKeys: boolean = false;
  // Opt-in: en mobile reemplaza el <select> nativo (no estilizable/acotable) por una.
  @Input() mobileTapList: boolean = false;

  listFiltroItems: { label: string; value: any }[] = [];
  isInputActive: boolean = false;

  isMobile: boolean = false;
  constructor(private elementRef: ElementRef) { }

  ngOnInit(): void {
    this.listFiltroItems = this.listItems;

    this.detectMobileDevice();
  }

  //Metodo para detectar si es un dispositivo movil 
  private detectMobileDevice(): void {
    this.isMobile = window.innerWidth <= 768 || 
            /Android|webOS|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  getItemByValue(value: any): any {
    if (!value || value === '') {
      return null;
    }
    const found = this.listItems.find(item => String(item.value) === String(value));
    return found || null;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['listItems']) {
      this.listFiltroItems = this.listItems;
    }
  }


  showSuggestions(show: boolean, force: boolean = false): void {
    let boxSuggestions = this.miElementoRef.nativeElement;
    if (boxSuggestions != undefined) {
      if (show) {
        boxSuggestions.style.display = 'block';
        this.isInputActive = true;
      } else {
        if (!boxSuggestions.matches(':hover')) {
          boxSuggestions.style.display = 'none';
          this.isInputActive = false;
        }
        if (force) {
          boxSuggestions.style.display = 'none';
          this.isInputActive = false;
        }
      }
    }
  }

  filtro(event: any) {
    const inputElement = event.target as HTMLInputElement;
    let filtroBusqueda = inputElement.value;

    if (this.preventNumberKeys) {
      const sanitizedValue = filtroBusqueda.replace(/\d+/g, '');
      if (sanitizedValue !== filtroBusqueda) {
        inputElement.value = sanitizedValue;
        if (this.selectItem && typeof this.selectItem === 'object') {
          this.selectItem.label = sanitizedValue;
        }
      }
      filtroBusqueda = sanitizedValue;
    }

    this.listFiltroItems = this.listItems.filter((p: { label: string; }) => p.label.toLowerCase().includes(filtroBusqueda.toLowerCase()));
    if (this.listFiltroItems.length === 0) {
      this.listFiltroItems = [];
    }
  }

  setValue(data: any) {
    if (!data) {
      return;
    }
    
    this.selectItem = data;
    // Cerrar sugerencias salvo en el <select> nativo de mobile (lo gestiona el SO)
    if (!this.isMobile || this.mobileTapList) {
      this.showSuggestions(false, true);
    }
    this.selectItemEvent.emit(data);
  }

  // Trigger táctil de la lista mobile 
  toggleMobileList(): void {
    this.showSuggestions(!this.isInputActive);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.mobileTapList || !this.isInputActive) {
      return;
    }
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showSuggestions(false, true);
    }
  }

  // Método específico para el select nativo de mobile
  onSelectChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const value = selectElement.value;
    
    const item = this.getItemByValue(value);
    
    if (item) {
      this.setValue(item);
    }
  }

  onInputKeydown(event: KeyboardEvent): void {
    if (this.preventNumberKeys && /^\d$/.test(event.key)) {
      event.preventDefault();
      return;
    }

    if (!this.preventDeleteKeys) {
      return;
    }

    if (event.key === 'Delete' || event.key === 'Backspace' || event.key === ' ' || event.key === 'Spacebar') {
      event.preventDefault();
    }
  }

}
